export const apiConfig ={
  cell_modem_list : 'api/cell_modems/plan_list',
  extend_data_plan: 'api/cell_modems/plan_extend',
  prices: 'api/cell_modems/prices',
  feedback_post_call : 'api/cell_modems/feedback'
}